import { combineReducers } from "redux";

import settingsReducer from "./settings/settings.reducer";
import accountReducer from "./account/account.reducer";

export default combineReducers({
  settings: settingsReducer,
  account: accountReducer,
});
